import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Radio,
  Button,
  Table,
  Switch,
  Row,
  Col,
  ColorPicker
} from 'antd'
import React, { use, useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import {
  OPTIONS_OBJECT_POST,
  OPTIONS_ROLE,
  TIME_PAKAGE
} from '../../configData'
import { userSearch } from '../../services/cmsservice'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

import { DeleteOutlined } from '@ant-design/icons'
import { useWatch } from 'antd/es/form/Form'

const { Option } = Select

const { TextArea } = Input

const FormPost = ({ form, mode, detailForm }) => {
  const [color, setColor] = useState('#000000') // Màu mặc định
  const [fontType, setFontType] = useState('UPPERCASE') // Mặc định chữ hoa

  const [packages, setPackages] = useState([
    {
      key: 1,
      feeName: '',
      feeType: '',
      origin_price: '',
      promotion_price: '',
      status: true
    }
  ])

  useEffect(() => {
    setPackages([{
      key: 1,
      feeName: '',
      feeType: '',
      origin_price: '',
      promotion_price: '',
      status: true
    }])
  }, [])
  useEffect(() => {
    if (detailForm.package_fee_info) {
      setPackages(detailForm.package_fee_info)
    }
  }, [detailForm.package_fee_info])

  // console.log('packageFeeInfo', packag eFeeInfo)
  const addPackage = () => {
    const newPackage = {
      key: Date.now(),
      feeName: '',
      feeType: '',
      origin_price: '',
      promotion_price: '',
      status: true
    }
    setPackages([...packages, newPackage])
  }
  const deletePackage = (key) => {
    setPackages(packages.filter((item) => item.key !== key))
  }

  const columns = [
    {
      title: 'Loại gói',
      dataIndex: 'feeType',
      width: '15%',
      render: (_, record) => (
        <Select
          defaultValue={record.feeType}
          style={{ width: '100%' }}
          onChange={(value) => updatePackage(record.key, 'feeType', value)}
        >
          <Option value="1DAY">3 ngày</Option>
          <Option value="7DAY">7 ngày</Option>
          <Option value="15DAY">15 ngày</Option>
          <Option value="30DAY">30 ngày</Option>
          <Option value="90DAY">90 ngày</Option>
          <Option value="PUSH_POST">Đẩy tin</Option>
        </Select>
      )
    },
    {
      title: 'Thời gian',
      dataIndex: 'feeName',
      render: (_, record) => (
        <Input
          defaultValue={record.feeName}
          // placeholder="Nhập tên gói"
          onChange={(e) => updatePackage(record.key, 'feeName', e.target.value)}
        />
      )
    },
    {
      title: 'Giá gốc',
      dataIndex: 'origin_price',
      render: (_, record) => (
        <InputNumber
          // defaultValue={record.origin_price}
          value={record.origin_price}
          placeholder="Nhập giá KM"
          min={0} // Không cho phép giá trị âm
          style={{ width: '100%' }}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
          onChange={(value) => updatePackage(record.key, 'origin_price', value)}
        />
      )
    },
    {
      title: 'Giá KM',
      dataIndex: 'promotion_price',
      render: (_, record) => (
        <InputNumber
          // defaultValue={record?.promotion_price}
          value={record.promotion_price}
          placeholder="Nhập giá KM"
          min={0} // Không cho phép giá trị âm
          style={{ width: '100%' }}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
          onChange={(value) =>
            updatePackage(record.key, 'promotion_price', value)
          }
        />
      )
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      render: (_, record) => (
        <Switch
          checked={record.status}
          onChange={(checked) => updatePackage(record.key, 'status', checked)}
        />
      )
    },
    {
      title: 'Hành động',
      dataIndex: 'action',
      render: (_, record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => deletePackage(record.key)}
        />
      )
    }
  ]

  const updatePackage = (key, field, value) => {
    setPackages((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, [field]: value } : item
      )
    )
  }

  useEffect(() => {
    form.setFieldsValue({ package_fee: packages })
  }, [packages, form])

  return (
    <Form
      form={form}
      // onFinish={handleSearch}
      labelWrap
      labelAlign="left"
      labelCol={{ span: 6 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
      disabled={mode == 'VIEW' ? true : false}
      initialValues={{
        font_type: 'UPPERCASE',
        title_color: '#000000'
      }}
    >
      <Form.Item name="package_fee" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Row>
        <Col span={24}>
          <Form.Item
            label="Tên gói"
            name="name"
            labelCol={{ span: 3 }}
            rules={[{ required: true, message: 'Vui lòng nhập tên gói' }]}
          >
            <Input placeholder="Nhập tên gói" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Độ ưu tiên"
            name="order"
            rules={[{ required: true, message: 'Vui lòng nhập độ ưu tiên' }]}
          >
            <Input placeholder="Nhập độ ưu tiên" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Đối tượng"
            name="type"
            rules={[{ required: true, message: 'Vui lòng chọn đối tượng' }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn đối tượng"
              // defaultValue="Tất cả"
            >
              {OPTIONS_OBJECT_POST.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <h3
        style={{
          color: form.getFieldValue('title_color') || color,
          textTransform:
            (form.getFieldValue('font_type') || fontType) == 'UPPERCASE'
              ? 'uppercase'
              : 'lowercase'
        }}
      >
        TÊN DỰ ÁN VINHOMES OCEAN PARK
      </h3>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Màu tiêu đề"
            name="title_color"
            rules={[{ required: true, message: 'Vui lòng chọn màu' }]}
          >
            <ColorPicker
              value={color}
              onChange={(color) => {
                setColor(color.toHexString())
                form.setFieldsValue({ title_color: color.toHexString() })
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Kiểu chữ tiêu đề"
            name="font_type"
            rules={[{ required: true, message: 'Vui lòng chọn kiểu chữ' }]}
          >
            <Radio.Group
              value={fontType}
              onChange={(e) => {
                const newFontType = e.target.value
                setFontType(newFontType)
              }}
            >
              <Radio value="UPPERCASE">Chữ hoa</Radio>
              <Radio value="LOWERCASE">Chữ thường</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Số người tiếp cận"
            name="people_quantity"
            rules={[{ required: true, message: 'Vui lòng nhập số người' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Nhập số người"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Số ảnh"
            name="image_quantity"
            rules={[{ required: true, message: 'Vui lòng nhập số ảnh' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Nhập số người"
            />
          </Form.Item>
        </Col>
      </Row>

      <Table
        dataSource={packages}
        columns={columns}
        pagination={false}
        style={{ marginTop: '16px' }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="primary" onClick={addPackage} style={{ margin: '16px 0' }}>
          Thêm gói phí
        </Button>
      </div>

      {/* <Row justify="space-between">
        <Button>Quay lại</Button>
        <Button type="primary">Thêm mới</Button>
      </Row> */}
    </Form>
  )
}

export default FormPost
